import { FROG_STATUS, TIMEOUT } from '../constants';
import { sendFrog } from '../services/frog';
import { getStorage, setStorage } from '../utils/StorageUtil';
import Entry from './Entry';
import Header from './Header';
import Config from '../config';
var Frog = /** @class */ (function () {
    function Frog(config) {
        this.frogMap = {};
        this.header = new Header(config);
        this.entry = new Entry(config);
        this.key = config.key || '_fr_g_v4_';
        this.url = config.url || Config.FROG_HOST;
        if (config.send) {
            this.sendMethod = config.send;
        }
        this.bindUnloadEvent();
    }
    Frog.prototype.clear = function () {
        this.clearItems();
    };
    Frog.prototype.send = function () {
        var _this = this;
        var urls = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            urls[_i] = arguments[_i];
        }
        this.pickExistItems();
        this.setItems(urls.map(function (url) { return _this.entry.getData(url); }));
        if (!Object.keys(this.frogMap).length) {
            return Promise.resolve('');
        }
        var entries = this.buildEntries();
        if (this.sendMethod && typeof this.sendMethod === 'function') {
            return this.sendByConfig(entries);
        }
        else {
            return this.sendByDefault(entries);
        }
    };
    Frog.prototype.add = function () {
        var urls = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            urls[_i] = arguments[_i];
        }
        return this.send.apply(this, urls);
    };
    // 兼容下 http://gerrit.zhenguanyu.com/#/c/407352/ 不过这个版本不需要调用setUserId也可以，直接修改frog config里的userId即可
    Frog.prototype.setUserId = function (userId) {
        if (userId) {
            this.header.setUserId(userId);
        }
    };
    Frog.prototype.bindUnloadEvent = function () {
        var _this = this;
        var handleUnloadEvent = function () { return _this.send(); };
        if (window.addEventListener) {
            window.addEventListener('beforeunload', handleUnloadEvent, false);
        }
        else if (window.attachEvent) {
            window.attachEvent('onbeforeunload', handleUnloadEvent);
        }
    };
    Frog.prototype.buildEntries = function () {
        var _this = this;
        var storageFrogMap = getStorage(this.key) || {};
        var entries = Object.keys(this.frogMap)
            .filter(function (key) {
            var item = _this.frogMap[key];
            return item.status === FROG_STATUS.INIT ||
                (item.status === FROG_STATUS.SENDING && new Date().getTime() > item.sendingTimeout);
        })
            .map(function (key) {
            var item = _this.frogMap[key];
            item.status = FROG_STATUS.SENDING;
            item.sendingTimeout = new Date().getTime() + TIMEOUT;
            storageFrogMap[key] = item;
            return item.data;
        });
        setStorage(this.key, storageFrogMap);
        return entries;
    };
    Frog.prototype.sendByConfig = function (entries) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.sendMethod(_this.url, {
                head: _this.header.getData(),
                entries: entries,
            }, function (err) {
                if (!err) {
                    _this.clearItems();
                }
                err ? reject(err) : resolve('');
            });
        });
    };
    Frog.prototype.sendByDefault = function (entries) {
        var _this = this;
        return sendFrog(this.url, {
            head: this.header.getData(),
            entries: entries,
        }).then(function (res) {
            _this.clearItems();
            return res;
        });
    };
    Frog.prototype.clearItems = function () {
        var _this = this;
        var storageFrogMap = getStorage(this.key) || {};
        Object.keys(this.frogMap).forEach(function (key) {
            delete _this.frogMap[key];
            if (storageFrogMap[key]) {
                delete storageFrogMap[key];
            }
        });
        setStorage(this.key, storageFrogMap);
    };
    Frog.prototype.setItems = function (entries) {
        var _this = this;
        entries.map(function (data) {
            return {
                data: data,
                status: FROG_STATUS.INIT,
            };
        }).forEach(function (item) {
            _this.frogMap[item.data.key] = item;
        });
    };
    Frog.prototype.pickExistItems = function () {
        var _this = this;
        var storageFrogMap = getStorage(this.key) || {};
        Object.keys(storageFrogMap).forEach(function (key) {
            var item = storageFrogMap[key];
            if (item.status === FROG_STATUS.SENDING && Date.now() > item.sendingTimeout) {
                _this.frogMap[key] = item;
            }
        });
    };
    return Frog;
}());
export default Frog;
